<div class="header-container">
  <div class="header-content">
    <div class="header-logo">
      <img src="assets/images/simple-black-logo.png" alt="logo" class="logo" />
    </div>
  </div>
  @if (loggedUser) {
  <div class="header-user">
    <span>{{ loggedUser.name }}</span>
    <img [src]="loggedUser.image" alt="user" class="image" />
    <i class="pi pi-sign-out logout" (click)="logout()"></i>
  </div>
  }
</div>
